module.exports = __webpack_public_path__ + "img/photo3_8.da038bb8.jpg";